$(document).ready(function(){
    jQuery.fn.toggleAttr = function(attr) {
        return this.each(function() {
         var $this = $(this);
         $this.attr(attr) ? $this.removeAttr(attr) : $this.attr(attr, attr);
        });
       };

    // $('.list-menu li').each(function(){
    //     var $this = $(this);
        
    //     $this.find('summary').hover(function(){
    //         // alert('jh');
    //         $(this).parents('details').toggleAttr('open');
    //     });

    //     $this.find('summary').click(function(e){
    //         e.preventDefault();
    //     });

    // });

    var highestBox = 0;
    
    // Select and loop the elements you want to equalise
    $('.announcement-bar').each(function(){
      
      // If this box is higher than the cached highest then store it
      if($(this).height() > highestBox) {
        highestBox = $(this).height(); 
      }
    
    });  
          
    // Set the height of all those children to whichever was highest 
    $('.announcement-bar').height(highestBox);
  
});